var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _g3, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaleRock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 342,
    fill: "none",
    viewBox: "0 0 165 342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_10593",
    width: 52,
    height: 91,
    x: 3,
    y: 36,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.85303 41.3777L43.7067 36.4843L54.1066 121.184L14.2529 126.078L3.85303 41.3777Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_10593)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M25.6374 118.095L26.162 118.707C32.1853 124.69 41.9146 124.654 47.8907 118.625C53.8672 112.598 53.8257 102.863 47.8045 96.8817L32.4591 81.6442L40.1031 59.1619C42.8374 51.1247 38.5393 42.3888 30.5056 39.6523C22.471 36.9161 13.7432 41.2135 11.0118 49.2518L11.0118 49.2521C3.87974 73.1937 9.38862 99.1234 25.6374 118.095Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC399",
    fillRule: "evenodd",
    d: "M73.3944 141.078C101.76 138.442 122.617 113.296 119.977 84.9071L118.907 69.9016C116.264 41.513 91.134 20.6395 62.7653 23.2776C34.3999 25.9132 13.5444 51.0587 16.1835 79.448L17.2562 94.4512C19.8955 122.842 45.0303 143.715 73.3944 141.078Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC399",
    fillRule: "evenodd",
    d: "M48.8465 129.173L68.3585 419.263C70.4282 436.119 101.628 446.161 118.473 444.092C135.318 442.024 155.378 425.688 153.309 408.832L109.846 121.684C107.776 104.825 92.4436 92.8372 75.5986 94.9055C58.7535 96.9738 46.7765 112.315 48.8465 129.173Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M26.367 68.959L27.4397 83.9619C29.0723 101.517 39.3103 116.188 53.5912 124.211C57.6899 126.514 60.3147 130.768 60.6226 135.462L78.5423 408.773C80.6119 425.629 119.895 434.677 136.74 432.608C141.357 432.042 145.587 430.452 149.283 428.133C144.602 436.098 128.347 442.88 118.473 444.092C101.628 446.161 70.4281 436.119 68.3584 419.263L50.2421 142.951C50.0412 139.889 48.2177 137.183 45.478 135.803C30.1223 128.072 18.9666 112.844 17.2559 94.4513L16.1832 79.4481C14.4843 61.179 22.5243 44.2653 36.0248 33.8178C28.896 43.614 25.1564 55.9413 26.367 68.959Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC399",
    fillRule: "evenodd",
    d: "M29.9528 69.541C30.7685 76.184 36.8031 80.9178 43.4483 80.1201C50.1032 79.3191 54.8501 73.2731 54.0504 66.612L49.1342 25.6721L49.1304 25.6406C48.3147 18.9973 42.2795 14.2615 35.6348 15.061C28.9806 15.8598 24.2329 21.9061 25.0325 28.5669L29.9486 69.5069L29.9528 69.541Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M30.1489 27.9387C30.1489 27.9387 30.7685 76.184 29.9528 69.541L29.9486 69.5066L25.0325 28.5669C24.2331 21.9058 28.9809 15.8597 35.6351 15.0609C36.5045 14.9566 37.3629 14.9504 38.2004 15.027C32.9312 16.8642 29.4563 22.1668 30.1489 27.9387Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_10593",
    width: 34,
    height: 71,
    x: 43,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M43.5347 9.43164L67.7385 6.45978L76.0026 73.7655L51.7988 76.7373L43.5347 9.43164Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_10593)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBC399",
    fillRule: "evenodd",
    d: "M50.3187 64.6828C51.1344 71.3258 57.1702 76.0593 63.8166 75.2615C70.4714 74.4605 75.2177 68.4122 74.4175 61.7536L69.2225 18.5457L69.2189 18.5164C68.403 11.8713 62.3672 7.1374 55.7222 7.93474C49.0662 8.73588 44.3208 14.7841 45.1211 21.443L50.3148 64.651L50.3187 64.6828Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_10593",
    width: 22,
    height: 59,
    x: 43,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M43.5347 9.43164L57.9885 7.65693L64.8473 63.5175L50.3935 65.2922L43.5347 9.43164Z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_10593)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M49.7298 20.8771C49.7298 20.8771 51.1344 71.3258 50.3187 64.6828L50.3148 64.651L45.1211 21.443C44.3208 14.7841 49.0662 8.73618 55.7222 7.93474C56.4976 7.84197 57.2645 7.83083 58.0164 7.88357C52.614 9.6405 49.0254 15.0193 49.7298 20.8771Z",
    clipRule: "evenodd"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC399",
    fillRule: "evenodd",
    d: "M67.07 20.2905L67.0738 20.322L72.4482 63.1742C73.284 69.8309 79.3523 74.5489 86.0035 73.7161C92.644 72.8825 97.3539 66.8271 96.5385 60.1865L96.5343 60.1524L91.1603 17.3025C90.3247 10.6458 84.2559 5.92573 77.6053 6.76058C70.9645 7.59421 66.2543 13.6475 67.07 20.2905Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M71.461 19.7514L71.4649 19.7828C71.4649 19.7828 73.284 69.8309 72.4482 63.1742L67.0738 20.322L67.07 20.2905C66.2543 13.6475 70.9645 7.59421 77.605 6.76061C78.3687 6.66471 79.1224 6.65032 79.8643 6.69517C74.3817 8.41571 70.7361 13.8478 71.461 19.7514Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC399",
    fillRule: "evenodd",
    d: "M88.7235 23.9974L88.7274 24.0289L94.1015 66.8791C94.9373 73.5354 101.006 78.2558 107.657 77.4206C114.297 76.587 119.007 70.534 118.192 63.891L118.188 63.8593L112.814 21.0073C111.978 14.3506 105.909 9.63265 99.2586 10.4654C92.6178 11.299 87.9079 17.3541 88.7235 23.9974Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M93.1132 23.4584L93.1171 23.4899C93.1171 23.4899 94.9368 73.5354 94.1013 66.879L88.7269 24.0289L88.7231 23.9975C87.9074 17.3542 92.6176 11.299 99.2581 10.4654C100.022 10.3693 100.776 10.3551 101.518 10.4021C96.0348 12.1227 92.388 17.5524 93.1132 23.4584Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M92.0234 140.085L97.2031 146.229"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M70.1401 132.26L69.687 140.284"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M81.1621 152.415L83.2174 160.185"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M100.496 126.98L102.551 134.75"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M101.025 203.697L103.08 211.467"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M119.519 328.096L121.574 335.866"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M103.793 275.906L105.849 283.677"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M107.406 230.603L110.652 237.955"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M117.54 298.17L120.786 305.522"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M116.519 215.536L118.574 223.306"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M129.369 317.604L133.725 324.358"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M105.849 308.927L106.574 316.866"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M123.519 281.096L125.574 288.866"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M91.8101 178.69L91.0749 186.694"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M78.2202 304.925L77.485 312.929"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M90.5596 220.327L89.8244 228.33"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M84.1382 269.295L83.403 277.298"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M91.2202 290.925L90.485 298.928"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M98.3931 247.383L100.174 255.221"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M70.4103 163.34L66.7668 170.502"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M58.4518 153.427L54.8083 160.589"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M77.4498 201.32L75.2905 209.061"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M75.1075 227.059L72.2821 234.582"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M76.1647 180.924L72.5212 188.086"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M80.5509 247.318L76.9074 254.48"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M64.5626 254.141L60.9191 261.302"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M60.2382 184.026L54.0862 189.192"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M102.013 162.557L106.623 169.139"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M107.264 188.527L111.875 195.109"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M91.8584 325.648L89.916 333.446"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.811,
    d: "M114.928 255.521L119.539 262.103"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleRock);
export default __webpack_public_path__ + "static/media/male_rock.9d6447b72c4bb9fb1297c539eec9f1a1.svg";
export { ForwardRef as ReactComponent };